// Default, client-side channel-label map. Maps known `channel_key` values
// (derived from fs_channel or utm_source) to friendly display names. Per the
// design doc (docs/design/campaign-channel-analytics.md) defaults must work with
// zero setup; server-side, per-subscription label overrides are a follow-up.
// Unknown keys fall back to a title-cased version of the raw key.

const DEFAULT_CHANNEL_LABELS: Record<string, string> = {
  marketo: 'Marketo',
  hubspot: 'HubSpot',
  salesforce: 'Salesforce',
  pardot: 'Pardot',
  mailchimp: 'Mailchimp',
  klaviyo: 'Klaviyo',
  sendgrid: 'SendGrid',
  youtube: 'YouTube',
  instagram: 'Instagram',
  facebook: 'Facebook',
  meta: 'Meta',
  tiktok: 'TikTok',
  linkedin: 'LinkedIn',
  x: 'X (Twitter)',
  twitter: 'X (Twitter)',
  pinterest: 'Pinterest',
  snapchat: 'Snapchat',
  google: 'Google',
  bing: 'Bing',
  newsletter: 'Newsletter',
  email: 'Email',
  sms: 'SMS',
  brand_site: 'Brand site',
  website: 'Website',
  blog: 'Blog',
  app: 'App',
  partner: 'Partner',
  affiliate: 'Affiliate',
};

/** Sentinel the backend returns for the no-channel bucket. */
export const UNTAGGED_CHANNEL = '(untagged)';

function titleCase(s: string): string {
  return s
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Friendly display label for a channel_key. Empty / untagged → the sentinel. */
export function channelLabel(channelKey: string): string {
  if (!channelKey || channelKey === UNTAGGED_CHANNEL) return UNTAGGED_CHANNEL;
  const key = channelKey.toLowerCase();
  return DEFAULT_CHANNEL_LABELS[key] ?? titleCase(channelKey);
}
